import PropTypes from 'prop-types'

import classNames from 'classnames'
import MixedBasicPreview from 'features/creative/preview/MixedBasicPreview'
import SiteUrlPropTypes from '../../channel/SiteUrlPropTypes'

const MixedCreativePreviewList = ({
  combinations = [],
  creative,
  siteUrl,
  isMobileView,
}) => (
  <>
    <div className="view_tit">
      <strong className="tit_view">확장소재 mix</strong>
      <span className="txt_view">
        등록된 확장소재의 조합으로 노출 가능한 일부 예시가 제공됩니다.
      </span>
    </div>
    <div
      className={classNames('view_detail', {
        view_mo: isMobileView,
        view_pc: !isMobileView,
      })}>
      {combinations.map(comb => (
        <MixedBasicPreview
          key={comb.join()}
          creative={creative}
          siteUrl={siteUrl}
          types={comb}
          isMobileView={isMobileView}
        />
      ))}
    </div>
  </>
)

export default MixedCreativePreviewList

MixedCreativePreviewList.propTypes = {
  combinations: PropTypes.array.isRequired,
  creative: PropTypes.object.isRequired,
  siteUrl: SiteUrlPropTypes,
  isMobileView: PropTypes.bool.isRequired,
}
